import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import routes from 'app/routes';
import IconWithText from 'components/Widgets/IconWithText';

export default function Index() {
  return (
    <section>
      <h4 className="mb-4">Learning Style and Preferences</h4>

      <Row>
        <Col sm={9} lg={10}>
          <IconWithText
            iconClassName="certified-icon big-icon bg-secondary"
            contentClassName="mb-3 mb-sm-0"
            wrapperClassName="align-items-start"
          >
            <p>
              Assessing working and learning styles helps you understand how you process and retain new information,
              {' '}
              and helps us to match you with a coach who can relate to you and your thinking process.
              {' '}
              The Learning Style Assessment sets you and your coach up for establishing clear communication and
              {' '}
              a trusting relationships for your first session.

              <br />

              You can also select your language, timezone and diversity preferences to ensure
              {' '}
              the best coaching experience with your coach.
            </p>
          </IconWithText>
        </Col>

        <Col sm={3} lg={2}>
          <a
            href={routes.members.learningStyle.show}
            className="btn btn-primary d-sm-block px-3 px-sm-0"
          >
            View
          </a>
        </Col>
      </Row>
    </section>
  );
}
